module.exports = __webpack_public_path__ + "static/assets/5bedbbb6aca874556ce398b47d1b7c22.svg";